import type { ClinicalSummaryCategory } from './clinicalSummaryCategoryStyles'
import type { ClinicalSummaryPhenotypeModelSpec } from './clinicalSummaryPhenotypeModel'

export interface ClinicalSummaryChipMoveTarget {
  category: ClinicalSummaryCategory
  label: string
}

/** "Move to <section>" for each option that does not already hold the chip's category. */
export function chipMoveTargets(
  model: Pick<ClinicalSummaryPhenotypeModelSpec, 'options' | 'sections'>,
  category: ClinicalSummaryCategory
): ClinicalSummaryChipMoveTarget[] {
  return model.options
    .filter((option) => !option.covers.includes(category))
    .map((option) => ({
      category: option.category,
      label: `Move to ${model.sections.find((section) => section.categories.includes(option.category))?.label ?? option.label}`,
    }))
}
